<template>
  <span
    class="badge px-2 py-1"
    :class="badgeClass"
  >
    {{ badgeText }}
  </span>
</template>

<script>
export default {
  name: "StatusBadge",
  props: {
    value: {
      type: [String, Number, Boolean],
      default: 0
    },
    activeText: {
      type: String,
      default: "Activo"
    },
    inactiveText: {
      type: String,
      default: "Inactivo"
    },
    activeClass: {
      type: String,
      default: "badge-success bg-success text-white"
    },
    inactiveClass: {
      type: String,
      default: "badge-secondary bg-secondary text-white"
    }
  },
  computed: {
    isActive() {
      return this.value == 1 || this.value === "1" || this.value === true;
    },
    badgeText() {
      return this.isActive ? this.activeText : this.inactiveText;
    },
    badgeClass() {
      return this.isActive ? this.activeClass : this.inactiveClass;
    }
  }
};
</script>
